import { useQuery } from '@apollo/client/react';
import { BookingStepper } from '@drycut/booking-components';
import { type CompleteStoreFragment, GetStoreDocument, type Maybe } from '@drycut/graphql';
import { Loader } from '@drycut/ui-components';
import { useNavigate, useParams } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

import StorePubSubWrapper from '../StorePubSubWrapper';

export function NewBooking(): React.ReactNode {
  useDocumentTitle('DRYCUT - Book');

  const { slug } = useParams() as { slug: string };
  const { data, loading } = useQuery(GetStoreDocument, { variables: { slug } });
  const navigate = useNavigate();

  const store: Maybe<CompleteStoreFragment> = data?.store || null;

  if (loading) {
    return <Loader />;
  }

  if (!store || !store.active) {
    navigate('/not-found');
    return null;
  }

  return (
    <StorePubSubWrapper slug={slug}>
      <BookingStepper store={store} />
    </StorePubSubWrapper>
  );
}
